<template>
  <div>
    <loader :isVisible="loading" />
    <StatsFilters
      :commercials="commercials"
      :ranks="ranks"
      :show-date="true"
      :dateDefault="defaultDates"
      @apply-filters="load"
    />

    <div class="card">
      <div class="card-block">
        <tabs v-model="activeTab" @input="handleNewActiveTab">
          <tab :header="endedHeader">
            <Fidelisation
              :ordersData="displayedOrders"
              :count="totals.ended"
              :limit="limit"
              :page="page"
              @showComment="displayComment"
              @updateRank="updateRank"
              @removeEntry="(...args) => this.removeEntry('ended', ...args)"
              @changePage="page = $event"
              @sort="sortField"
            />
          </tab>

          <tab :header="inProgressHeader" ref="test">
            <Fidelisation
              :ordersData="displayedOrders"
              :count="totals.inProgress"
              :limit="limit"
              :page="page"
              @showComment="displayComment"
              @updateRank="updateRank"
              @removeEntry="
                (...args) => this.removeEntry('inProgress', ...args)
              "
              @changePage="page = $event"
              @sort="sortField"
            />
          </tab>

          <tab :header="followedHeader">
            <Fidelisation
              :ordersData="displayedOrders"
              :count="totals.followed"
              :followed="true"
              :limit="limit"
              :page="page"
              @showComment="displayComment"
              @updateRank="updateRank"
              @removeEntry="(...args) => this.removeEntry('followed', ...args)"
              @changePage="page = $event"
              @sort="sortField"
            />
          </tab>

          <tab :header="conversionHeader">
            <Fidelisation
              :ordersData="displayedOrders"
              :count="totals.conversion"
              :limit="limit"
              :page="page"
              @showComment="displayComment"
              @updateRank="updateRank"
              @removeEntry="
                (...args) => this.removeEntry('conversion', ...args)
              "
              @changePage="page = $event"
              @sort="sortField"
            />
          </tab>

          <tab :header="archivedHeader">
            <Fidelisation
              :ordersData="displayedOrders"
              :count="totals.archived"
              :limit="limit"
              :page="page"
              @showComment="displayComment"
              @updateRank="updateRank"
              @removeEntry="(...args) => this.removeEntry('archived', ...args)"
              @changePage="page = $event"
              @sort="sortField"
            />
          </tab>
        </tabs>
      </div>
    </div>

    <modal
      v-if="modalUpdateComment.order"
      title="Commentaire"
      v-model="modalUpdateComment.showComment"
      cancelText="Annuler"
      okText="Enregistrer"
      @ok="updateComment()"
      effect="fade/zoom"
    >
      <textarea
        v-model="modalUpdateComment.order.fidelisation.notes"
        cols="30"
        rows="10"
        class="form-control form-normalization"
      >
      </textarea>
    </modal>

    <modal
      v-if="
        modalUpdateRank.order &&
        hasPermission($store.state.user, 'CLIENTS_WRITE')
      "
      title="Confirmer"
      v-model="modalUpdateRank.show"
      effect="fade/zoom"
    >
      <p>Convertir le pack en "Perdu" ?</p>
      Raison :
      <el-select
        v-model="modalUpdateRank.editClientLostReason"
        size="mini"
        class="w-100"
        placeholder="Choisir une cause pour pouvoir enregistrer la modification"
      >
        <el-option
          v-for="reason in lostReasons"
          :key="reason.value"
          :value="reason.value"
          :label="reason.label"
        />
      </el-select>

      <div v-if="getDetailsLostReason.length > 0" class="mt-1">
        Détails :
        <el-select
          v-model="modalUpdateRank.detailLostReason"
          size="mini"
          class="w-100"
          placeholder="Choisir un détail"
        >
          <el-option
            v-for="detail in getDetailsLostReason"
            :key="detail.value"
            :value="detail.value"
            :label="detail.label"
          />
        </el-select>
      </div>

      <div slot="modal-footer" class="modal-footer">
        <button
          type="button"
          class="btn btn-default"
          @click="modalUpdateRank.show = false"
        >
          Annuler
        </button>

        <button
          type="button"
          class="btn btn-primary"
          :disabled="modalUpdateRank.editClientLostReason === null"
          @click="updateLostRank()"
        >
          Enregistrer
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import moment from "moment";

import { mapGetters } from "vuex";
import Modal from "vue-strap/src/Modal";

import mixin from "@/mixin";
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

import Loader from "@/components/utils/Loader";
import StatsFilters from "@/components/stats/StatsFilters";
import Fidelisation from "@/components/fidelisation/Fidelisation";

export default {
  components: {
    StatsFilters,
    Tabs,
    Tab,
    Fidelisation,
    Modal,
    Loader,
  },

  mixins: [mixin],

  data() {
    return {
      defaultDates: {
        begin: moment().subtract(1, "y").toLocaleString(),
        end: moment().toLocaleString(),
      },
      concepts: [],
      commercials: [],
      activeTab: 0,
      fidelisations: {
        inProgress: [],
        ended: [],
        followed: [],
        conversion: [],
        archived: [],
      },
      totals: {
        inProgress: 0,
        ended: 0,
        followed: 0,
        conversion: 0,
        archived: 0,
      },
      modalUpdateComment: {
        showComment: false,
        order: null,
      },
      modalUpdateRank: {
        show: false,
        order: null,
        editClientLostReason: null,
        detailLostReason: null,
      },
      page: 1,
      limit: 15,
      form: {},
      loading: false,
      sort: {},
    };
  },

  watch: {
    activeTab(newVal, oldVal) {
      if (newVal !== oldVal) {
        const status = () => {
          switch (oldVal) {
            case 0:
              return "ended";
            case 1:
              return "inProgress";
            case 2:
              return "followed";
            case 3:
              return "conversion";
            case 4:
              return "archived";
            default:
              return null;
          }
        };

        this.fidelisations[status()] = [];
        this.totals[status()] = 0;
      }
    },
  },

  computed: {
    fidelisationStatus() {
      switch (this.activeTab) {
        case 0:
          return "ended";
        case 1:
          return "inProgress";
        case 2:
          return "followed";
        case 3:
          return "conversion";
        case 4:
          return "archived";
        default:
          return null;
      }
    },

    ...mapGetters({
      lostReasons: "getLostReasons",
      ranks: "getFidelisationRanks",
    }),

    inProgressHeader() {
      return `<i class="icon-user"></i> Bientôt fini ${
        this.totals.inProgress !== 0 ? "(" + this.totals.inProgress + ")" : ""
      }`;
    },

    endedHeader() {
      return `<i class="icon-user"></i> Pack fini ${
        this.totals.ended !== 0 ? "(" + this.totals.ended + ")" : ""
      }`;
    },

    followedHeader() {
      return `<i class="icon-user"></i> Pack suivi ${
        this.totals.followed !== 0 ? "(" + this.totals.followed + ")" : ""
      }`;
    },

    conversionHeader() {
      return `<i class="icon-user"></i> Pack Conversion ${
        this.totals.conversion !== 0 ? "(" + this.totals.conversion + ")" : ""
      }`;
    },

    archivedHeader() {
      return `<i class="icon-user"></i> Archivé ${
        this.totals.archived !== 0 ? "(" + this.totals.archived + ")" : ""
      }`;
    },

    displayedOrders() {
      const sorted = [...this.fidelisations[this.fidelisationStatus]].sort(
        (a, b) => {
          if (this.sort.order === "ascending") {
            if (this.sort.prop === "createdAt") {
              return moment(a[this.sort.prop]) - moment(b[this.sort.prop]);
            }

            return a[this.sort.prop] > b[this.sort.prop] ? 1 : -1;
          }

          if (this.sort.order === "descending") {
            if (this.sort.prop === "createdAt") {
              return moment(b[this.sort.prop]) - moment(a[this.sort.prop]);
            }

            return a[this.sort.prop] < b[this.sort.prop] ? 1 : -1;
          }

          return moment(b.createdAt) - moment(a.createdAt);
        },
      );

      const offset = this.page * this.limit - this.limit;

      return sorted.slice(offset, offset + this.limit);
    },

    getDetailsLostReason() {
      const detailsLostReason = this.lostReasons.find(
        (reason) => reason.value === this.modalUpdateRank.editClientLostReason,
      )?.details;

      return Array.isArray(detailsLostReason) ? detailsLostReason : [];
    },
  },

  created() {
    this.fetchCommercials();
  },

  methods: {
    async fetchCommercials() {
      const { data } = await this.$api.get("/users/commercials/search");

      this.commercials = data.map((c) => ({
        value: c.email,
        label: c.commercial.pseudo,
      }));
    },

    async sortField(fields) {
      this.sort = fields;

      this.page = 1;
    },

    async load(form) {
      this.form = form;

      await this.applyFilters();
    },

    async applyFilters() {
      try {
        this.loading = true;

        const { data } = await this.$api.get("/orders/fidelisation", {
          params: {
            begin: this.form.begin ? this.form.begin : null,
            end: this.form.end ? this.form.end : null,
            client: this.form.client ? this.form.client.value : null,
            coach: this.form.coach ? this.form.coach.value : null,
            status: this.form.status ? this.form.status.value : null,
            concept: this.form.concept,
            archived: this.fidelisationStatus === "archived" ? 1 : 0,
            completed: this.fidelisationStatus === "ended" ? 1 : 0,
            nearend: this.fidelisationStatus === "inProgress" ? 1 : 0,
            followed: this.fidelisationStatus === "followed" ? 1 : 0,
            conversion: this.fidelisationStatus === "conversion" ? 1 : 0,
            rank: this.form.rank ? this.form.rank.value : null,
            commercial: this.form.commercial
              ? this.form.commercial.value
              : null,
          },
        });

        switch (this.fidelisationStatus) {
          case "inProgress":
            this.fidelisations.inProgress = data.orders;
            this.totals.inProgress = data.count;
            break;
          case "ended":
            this.fidelisations.ended = data.orders;
            this.totals.ended = data.count;
            break;
          case "followed":
            this.fidelisations.followed = data.orders;
            this.totals.followed = data.count;
            break;
          case "conversion":
            this.fidelisations.conversion = data.orders;
            this.totals.conversion = data.count;
            break;
          case "archived":
            this.fidelisations.archived = data.orders;
            this.totals.archived = data.count;
            break;
        }

        this.page = 1;
      } catch (e) {
        this.$errorToast("Impossible de charger les packs fidélisation");
      } finally {
        this.loading = false;
      }
    },

    handleNewActiveTab() {},

    displayComment(attribution) {
      this.modalUpdateComment.showComment = true;
      this.modalUpdateComment.order = attribution;
    },

    async updateComment() {
      await this.$api
        .put(`/orders/fidelisation/${this.modalUpdateComment.order.id}`, {
          fidelisation: this.modalUpdateComment.order.fidelisation,
        })
        .catch((err) => {
          console.log(err);
        });

      this.modalUpdateComment.showComment = false;
    },

    async updateRank(order, rank) {
      if (rank === "pending" || rank === "fidelisation") {
        const message =
          rank === "pending"
            ? 'Convertir le pack "En attente" ?'
            : 'Convertir le pack en "Fidélisation" ?';

        this.$confirm({
          message,
          onConfirm: async () => {
            await this.$api
              .put(`/orders/fidelisation/${order.id}`, {
                rank,
                fidelisation: order.fidelisation,
              })
              .catch((err) => {
                console.log(err);
              });

            order.rank = rank;
          },
        });
      }

      if (rank === "lost") {
        this.modalUpdateRank.show = true;
        this.modalUpdateRank.order = order;
      }
    },

    async updateLostRank() {
      this.modalUpdateRank.order.rank = "lost";
      const order = this.modalUpdateRank.order;

      order.fidelisation.lostReason = this.modalUpdateRank.editClientLostReason;
      order.fidelisation.detailLostReason =
        this.modalUpdateRank.detailLostReason;

      await this.$api
        .put(`/orders/fidelisation/${order.id}`, {
          rank: "lost",
          fidelisation: order.fidelisation,
        })
        .catch((err) => {
          console.log(err);
        });

      this.modalUpdateRank.show = false;
    },

    removeEntry(array, id) {
      this.fidelisations[array] = this.fidelisations[array].filter(
        (f) => f.id !== id,
      );
      this.totals[array] = this.fidelisations[array].length;
    },
  },
};
</script>

<style type="text/css">
.fidelisation-modal .modal-dialog {
  max-width: 80%;
}
</style>
